import 'swiper/swiper-bundle.css'; // Correct path to Swiper's CSS
import Swiper from 'swiper';
import {Navigation, Pagination} from "swiper/modules";

export function SwiperInit() {
    return new Swiper('.swiper', {
        modules: [Pagination, Navigation],
        direction: 'horizontal',
        slidesPerView: 'auto',
        spaceBetween: 0,
        allowTouchMove: false,  // Disable touch move; set to true if needed
        pagination: {
            el: '.swiper-pagination',
            clickable: true,  // Change to true if you want the pagination to be clickable
            type: 'progressbar',
        },
        on: {
            init: function () {
                $(document.body).trigger('slider_logic', [this]);
            },
            slideChange: function () {
                $(document.body).trigger('slider_logic', [this]);
            },
        },
    });
}
